import React, { createContext, useContext, useState } from "react";
import axiosInstance from "../services/axiosService";

const LockContextApi = createContext();
const useLockContext = () => useContext(LockContextApi);

const LockContext = ({ children }) => {
  // const [selectedVariable, setSelectedVariable] = useState({ key: "", value: "", type: "" });
  const [allLockData, setAllLockData] = useState([]);

  const fetchAllLocks = async () => {
    const { data } = await axiosInstance.get(`/app/lock`);
    setAllLockData(data);
  };

  const getLockConfig = () => {
    return allLockData;
  };

  return (
    <LockContextApi.Provider
      value={{
        //selectedVariable,
        allLockData,
        fetchAllLocks,
        // setSelectedVariable,
        setAllLockData,
        getLockConfig
      }}
    >
      {children}
    </LockContextApi.Provider>
  );
};

export default LockContext;
export { useLockContext };
